import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.TOUR_SHARE_TEMPLATES}/${endpoint ? endpoint : ""}`

export const tourShareTemplatesService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTourShareTemplates: builder.query({
      query: () => ({
        url: buildUrl("index"),
        method: "GET",
      }),
      providesTags: (result) =>
        result?.templates
          ? [
              ...result.templates.map(({ id }) => ({ type: "TourShareTemplate", id })),
              { type: "TourShareTemplate", id: "LIST" },
            ]
          : [{ type: "TourShareTemplate", id: "LIST" }],
    }),
    createTourShareTemplate: builder.mutation({
      query: (body) => ({
        url: buildUrl("create"),
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "TourShareTemplate", id: "LIST" }],
    }),
    updateTourShareTemplate: builder.mutation({
      query: ({ id, ...body }) => ({
        url: buildUrl(id),
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "TourShareTemplate", id },
        { type: "TourShareTemplate", id: "LIST" },
      ],
    }),
    deleteTourShareTemplate: builder.mutation({
      query: (id) => ({
        url: buildUrl(id),
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "TourShareTemplate", id: "LIST" }],
    }),
    setDefaultTourShareTemplate: builder.mutation({
      query: (id) => ({
        url: buildUrl(`${id}/set_default`),
        method: "POST",
      }),
      invalidatesTags: [{ type: "TourShareTemplate", id: "LIST" }],
    }),
  }),
})

export const {
  useGetTourShareTemplatesQuery,
  useCreateTourShareTemplateMutation,
  useUpdateTourShareTemplateMutation,
  useDeleteTourShareTemplateMutation,
  useSetDefaultTourShareTemplateMutation,
} = tourShareTemplatesService
